import React from "react";

type HeadingLevels = "h1" | "h2" | "h3" | "h4";
type HeadingStyles = { [key in HeadingLevels]: string };

export const Heading = (props: {
  level: HeadingLevels;
  className?: string;
  children: React.ReactNode;
}) => {
  const { level, className, children } = props;

  const defaultStyles: HeadingStyles = {
    h1: "text-3xl md:text-[52px] lg:text-[76px] font-bold",
    h2: "text-4xl lg:text-[56px] font-bold",
    h3: "",
    h4: "text-lg font-bold",
  };

  const combinedClasses = `${defaultStyles[level]} ${className}`;

  return React.createElement(level, { className: combinedClasses }, children);
};
